<template>
  <v-autocomplete
    v-model="myValue"
    :color="color"
    :item-color="itemColor"
    :label="label"
    :items="items"
    :search-input.sync="searchInput"
    :loading="loading"
    :placeholder="placeholder"
    :no-data-text="noDataText"
    item-text="value"
    item-value="value"
    return-object
    :hide-details="hideDetails"
    hide-selected
    :outlined="outlined"
    :disabled="disabled"
    :height="46"
    chips
    :rules="rules"
    @focus="focus"
    @blur="blur"
    @change="$emit('change', myValue)"
  >
    <template v-slot:selection="data">
      <v-chip
        color="#f5f5f5"
        :close="close"
        @click:close="remove(data.item)"
      >
        <v-avatar left>
          <v-img :src="data.item.icon || defaultIcon" />
        </v-avatar>
        <span style="font-weight: 300; font-size: 12px;">
          {{ data.item.name }}
        </span>
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item" />
      </template>
      <template v-else>
        <v-list-item-avatar size="24">
          <img :src="data.item.icon || defaultIcon">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            style="font-size: 12px;height: 12px;line-height: 14px;"
          >
            {{ data.item.name }}
          </v-list-item-title>
          <v-list-item-title
            style="font-size: 12px;height: 12px;line-height: 14px;color: grey"
          >
            {{ data.item.email }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
  // # ms - new file
  import { mapState } from 'vuex'

  export default {
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          msId: null,
          email: null,
          name: null,
          icon: null
        })
      },
      label: {
        type: String,
        default: ''
      },
      hideDetails: {
        type: Boolean,
        default: true
      },
      outlined: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: Array,
        default: () => ([])
      },
      color: {
        type: String,
        default: 'primary'
      },
      itemColor: {
        type: String,
        default: 'primary'
      },
      placeholder: {
        type: String,
        default: ' '
      },
      noDataText: {
        type: String,
        default: 'Please input'
      },
      showIcon: {
        type: Boolean,
        default: true
      },
      close: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        defaultIcon: require('@/assets/avatar.png'),
        loading: false,
        myValue: {
          value: '',
          msId: '',
          email: '',
          name: '',
          icon: '',
          obj: {}
        },
        searchInput: null,
        items: []
      }
    },
    computed: {
      ...mapState(['msal']),
      outValue () {
        return this.myValue ? {
          msId: this.myValue.msId || '',
          email: this.myValue.email || '',
          name: this.myValue.name || '',
          icon: this.myValue.icon || ''
        } : {
          msId: '',
          email: '',
          name: '',
          icon: ''
        }
      }
    },
    watch: {
      value: {
        deep: true,
        handler (val, oVal) {
          this.setMyValue(val)
        }
      },
      searchInput: {
        deep: true,
        async handler (val, oVal) {
          let result = []
          if (val && val.length > 2 && val === this.searchInput) {
            try {
              this.loading = true
              let response = await this.axios({
                method: 'get',
                url:
                  this.msal.graphApi +
                  '/users' +
                  '?$filter=endsWith(mail,\'@nielseniq.com\')' +
                  '&$search="displayName:' + val + '" OR "mail:' + val + '"',
                headers: {
                  'Content-Type': 'application/json',
                  'ConsistencyLevel': 'eventual',
                  'Authorization': this.msal.accessToken
                }
              })
              result = this.lodash.get(response, 'data.value')
              if (!(result instanceof Array)) { result = [] }
            } catch (e) {}
          }
          if (val === this.searchInput) {
            // set item
            this.items = result
              // .filter((el, i) => i < 5)
              .map(el => ({
                value: el.id + ';' + el.displayName + ';' + el.mail.toLowerCase(),
                msId: el.id,
                email: el.mail.toLowerCase(),
                name: el.displayName,
                icon: el.icon,
                obj: el
              }))
            // get icon
            this.getItemsIcons(val)
          }
          this.loading = false
          if (this.myValue && this.myValue.name) this.items.push(this.myValue)
        }
      }
    },
    beforeMount () {
      this.setMyValue(this.value)
    },
    methods: {
      setMyValue (val) {
        try {
          if (val.msId !== this.myValue.msId || val.email !== this.myValue.email || val.name !== this.myValue.name || val.icon !== this.myValue.icon) {
            this.myValue = {
              value: (val.msId + ';' + val.name + ';' + val.email) || '',
              msId: val.msId || '',
              email: val.email || '',
              name: val.name || '',
              icon: val.icon || ''
            }
            this.searchInput = val.email || ''
          }
        } catch (e) {}
      },
      remove (item) {
        this.items = []
        this.myValue = undefined
        // const index = this.items.indexOf(item.name)
        // if (index >= 0) this.items.splice(index, 1)
      },
      focus (val) {
        this.$emit('focus', val)
      },
      blur (val) {
        this.$emit('blur', val)
      },
      async getItemsIcons (searchInput) {
        // get icon
        for (let indexItems = 0; indexItems < this.items.length; indexItems++) {
          if (searchInput !== this.searchInput) { return }
          const msId = this.items[indexItems].msId
          let imageData = ''
          try {
            let responseImg = await this.axios({
              method: 'get',
              url: this.msal.graphApi +
                '/users/' + msId + '/photos/48x48/$value',
              headers: {
                'Content-Type': 'image/jpg',
                'Authorization': this.msal.accessToken
              },
              responseType: 'arraybuffer' // important!!!
            })
            imageData = this.lodash.get(responseImg, 'data')
          } catch {
            // do nothing
          }
          let binary = ''
          const unit8Image = new Uint8Array(imageData)
          for (let i = 0; i < unit8Image.byteLength; i++) {
            binary += String.fromCharCode(unit8Image[i])
          }
          if (msId === this.items[indexItems].msId) {
            this.items[indexItems].icon =
              binary
                ? 'data:image/jpeg;base64,' + window.btoa(binary)
                : ''
          } else {
            return
          }
        }
      }
    }
  }
</script>

<style>

</style>
